import React from 'react';
import { object, string } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';

import './style.scss';

const CheckoutCta = ({ className, price }, { general }) => {
    const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREEN;

    return (
        <Button className={className}
            type="submit"
            color={btnColor}>
            <I18n k={'gig_page_perseus.packages.continue'}/>
            <span> ({price})</span>
        </Button>
    );
};

CheckoutCta.propTypes = {
    className: string,
    price: string
};

CheckoutCta.contextTypes = {
    general: object
};

export default CheckoutCta;
